import { React, useState, useEffect } from "react";
import ReactPaginate from "react-paginate";
import axios from "axios";
import PropTypes from "prop-types";
import { Room as RoomIcon, ThumbUpOffAlt, ThumbDownOffAlt, Visibility as VisibilityIcon, ThumbUpAlt, ThumbDownAlt, RestartAlt as RestartAltIcon, Email } from "@mui/icons-material";
import Tooltip from "@mui/material/Tooltip";

function ResearchApplicantTable(props) {
  const { applicants, selectedApplicant, setApplicant, userType, updateTable, setUpdateTable, updateLike, setUpdateLike, updateOffset, updateView, setUpdateView, editedTable,
    setEditedTable, setApplicantOffset, handleChange, setHandleChange, currentPage, setCurrentPage } = props;
  const [itemOffset, setItemOffset] = useState(0);

  const handleLike = applicantId => {
    const body = new FormData();
    body.append("applicantId", applicantId);
    axios.post("/faculty/likeApplicant", body).then((res) => {
      const data = res.data;
      if (data.success) {
        setUpdateLike(!updateLike);
        setHandleChange(true);
        setApplicantOffset(applicantId);
      }
    });
  };

  const handleViewed = applicant => {
    if (!applicant.viewed) {
      const body = new FormData();
      body.append("applicantId", applicant.applicationId);
      axios.post("/faculty/viewApplicant", body).then((res) => {
        const data = res.data;
        if (data.success) {
          setApplicant(applicant);
          setUpdateView(!updateView);
          setHandleChange(true);
          setApplicantOffset(applicant.applicationId);
        }
      });
    }
    else {
      setApplicant(applicant);
    }
  };

  const handleDislike = applicantId => {
    const body = new FormData();
    body.append("applicantId", applicantId);
    axios.post("/faculty/dislikeApplicant", body).then((res) => {
      const data = res.data;
      if (data.success) {
        setUpdateLike(!updateLike);
        setHandleChange(true);
        setApplicantOffset(applicantId);
      }
    });
  };

  const handleReset = (applicantId) => {
    if (confirm("Are you sure you would like to reset this application's viewing status?")) {
      const body = new FormData();
      body.append("applicantId", applicantId);
      axios.post("/faculty/resetApplicantViewStatus", body).then((res) => {
        const data = res.data;
        if (data.success) {
          setEditedTable(!editedTable);
          setHandleChange(true);
          setApplicantOffset(applicantId);
        }
      });
    }
  };

  useEffect(() => {
    setItemOffset(0);
  }, [updateOffset]);

  useEffect(() => {
    if (!handleChange) {
    }
    else {
      setHandleChange(false);
    }
  }, [applicants]);

  const items = applicants.map((applicant, index) => (
    <div
      className={"ResearchApplicantButton-container flex p-2 rounded-md border-2 drop-shadow-2xl mb-2" + (applicant.applicationId === selectedApplicant.applicationId ? " border-brand-primary" : "")}
      key={index}
    >
      <div className="ResearchApplicantButton-leftContainer w-full flex flex-col">
        <button
          type="button"
          className="w-full p-0 capitalize border-b last:border-b-0"
          onClick={() => handleViewed(applicant)}
        >
          <div className="ResearchApplicantButton-title text-xl font-bold font-brand-primary text-start flex mb-2">
            {applicant.pos_title}
          </div>

          <div className="ResearchApplicantButton-location text-base mb-3 flex justify-start py-auto">
            <RoomIcon fontSize="medium" className="flex my-auto mr-1" />
            {(applicant.location != "undefined") && (
              <div className="text-start">{applicant.pos_location}</div>
            )}
          </div>
          <div className="ResearchApplicantButton-title text-xl font-bold font-brand-primary text-start flex mb-2">
            {applicant.student_fname} {applicant.student_lname}
          </div>

          {applicant.student_csType === "Major" || applicant.student_csType === "Minor" ? (
            <div className="ApplicantButton-topContainer flex justify-between">
              <div className="ApplicantButton-yearType text-lg font-brand-primary flex">
                CS {applicant.student_csType} | {" "} {applicant.student_gradYear}
              </div>
            </div>
          ) : (
            <div className="ApplicantButton-topContainer flex justify-between">
              <div className="ApplicantButton-yearType text-lg font-brand-primary flex">
                {applicant.student_gradYear}
              </div>
            </div>
          )}
          {(applicant.viewed === true) && (
            <div className="ResearchPositionButton-viewCount text-base font-brand-primary flex">
              Viewed
            </div>
          )}

        </button>
      </div>
      <div className="ApplicantButton-rightContainer">
        {userType === "faculty" && (
          <button
            className="flex"
            onClick={() => handleLike(applicant.applicationId)}
          >
            {applicant.like_status === "like" ? (
              <Tooltip title="Like" placement="right">
                <div>
                  <ThumbUpAlt fontSize="large" sx={{ color: "#2196f3" }} />
                </div>
              </Tooltip>
            ) : (
              <Tooltip title="Like" placement="right">
                <div>
                  <ThumbUpOffAlt fontSize="large" sx={{ color: "#2196f3" }} />
                </div>
              </Tooltip>
            )}
          </button>
        )}
        {(userType === "faculty") && (
          <button className="flex" onClick={() => handleDislike(applicant.applicationId)}>
            {applicant.like_status === "dislike" ? (
              <Tooltip title="Dislike" placement="right">
                <div>
                  <ThumbDownAlt fontSize="large" sx={{ color: "#f44336" }} />
                </div>
              </Tooltip>
            ) : (
              <Tooltip title="Dislike" placement="right">
                <div>
                  <ThumbDownOffAlt fontSize="large" sx={{ color: "#f44336" }} />
                </div>
              </Tooltip>
            )}
          </button>
        )}

        {(userType === "faculty" && applicant.viewed === true) && (
          <button className="flex" onClick={() => handleReset(applicant.applicationId)}>
            <Tooltip title="Reset View Status" placement="right">
              <div>
                <VisibilityIcon fontSize="large" sx={{ color: "black" }} />
              </div>
            </Tooltip>
          </button>
        )}

        {(userType === "faculty") && (

          <button className="flex" onClick={() => window.location.href = "mailto:" + applicant.student_email + "?subject=Subject Here&body=Body Content Here"}>
            <Tooltip title="Email" placement="right">
              <div>
                <Email fontSize="large" sx={{ color: "black" }} />
              </div>
            </Tooltip>
          </button>
        )}
      </div>
    </div>
  ));

  const itemsPerPage = 5;
  const endOffset = itemOffset + itemsPerPage;
  const currentItems = items.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(items.length / itemsPerPage);

  // Invoke when user click to request another page.
  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % items.length;
    setItemOffset(newOffset);
    setCurrentPage(event.selected);
    if (applicants.length > newOffset) {
      setApplicant(applicants[newOffset]);
    }
  };

  if (applicants.length === 0) {
    return (
      <div className="ResearchApplicantTable bg-white p-2 mr-4 rounded-xl h-5/6">No research applicants found.</div>);
  } else {
    return (
      <div className="ResearchApplicantTable bg-white p-2 mr-4 rounded-xl h-full" style={{ minHeight: "816px" }}>
        <ReactPaginate
          forcePage={currentPage}
          breakLabel="..."
          nextLabel=">"
          onPageChange={handlePageClick}
          pageRangeDisplayed={3}
          pageCount={pageCount}
          previousLabel="<"
          renderOnZeroPageCount={null}
          className="flex w-full justify-between mb-6 mt-4 [&>li>a]:py-4 [&>li>a]:px-6 [&>li>a]:border [&>li>a]:rounded-lg [&>li.selected>a]:border-brand-primary"
        />
        <div className="ResearchApplicantTable-currentResearchApplicant overflow-y-auto">
          {currentItems}
        </div>
      </div>
    );
  }
}

ResearchApplicantTable.propTypes = {
  applicants: PropTypes.arrayOf(PropTypes.shape({
    applicationId: PropTypes.number,
    applicationDescription: PropTypes.string,
    viewed: PropTypes.bool,
    likeStatus: PropTypes.string,
    pos_detials: PropTypes.string,
    pos_loc: PropTypes.string,
    pos_title: PropTypes.string,
    resume: PropTypes.string,
    student_bio: PropTypes.string,
    student_csType: PropTypes.string,
    student_email: PropTypes.string,
    student_fname: PropTypes.string,
    student_lname: PropTypes.string,
    student_gradYear: PropTypes.string,
    student_academicYear: PropTypes.string,
    student_pid: PropTypes.string,
  })),
  selectedApplicant: PropTypes.shape({
    applicationId: PropTypes.number,
    applicationDescription: PropTypes.string,
    viewed: PropTypes.bool,
    likeStatus: PropTypes.string,
    pos_detials: PropTypes.string,
    pos_loc: PropTypes.string,
    pos_title: PropTypes.string,
    resume: PropTypes.string,
    student_bio: PropTypes.string,
    student_csType: PropTypes.string,
    student_email: PropTypes.string,
    student_fname: PropTypes.string,
    student_lname: PropTypes.string,
    student_gradYear: PropTypes.string,
    student_academicYear: PropTypes.string,
    student_pid: PropTypes.string,
  }),
  setApplicant: PropTypes.func,
  userType: PropTypes.string,
  updateTable: PropTypes.bool,
  setUpdateTable: PropTypes.func,
  updateLike: PropTypes.bool,
  setUpdateLike: PropTypes.func,
  updateOffset: PropTypes.bool,
  updateView: PropTypes.bool,
  setUpdateView: PropTypes.func,
  editedTable: PropTypes.bool,
  setEditedTable: PropTypes.func,
  setApplicantOffset: PropTypes.func,
  handleChange: PropTypes.bool,
  setHandleChange: PropTypes.func,
  currentPage: PropTypes.string,
  setCurrentPage: PropTypes.func
};

ResearchApplicantTable.defaultProps = {
  applicants: [],
  selectedApplicant: {},
  setApplicant: () => { },
  userType: "",
  updateTable: false,
  setUpdateTable: () => { },
  updateLike: false,
  setUpdateLike: () => { },
  updateOffset: () => { },
  updateView: false,
  setUpdateView: () => { },
  editedTable: false,
  setEditedTable: () => { },
  setApplicantOffset: () => { },
  handleChange: false,
  setHandleChange: () => { },
  currentPage: "",
  setCurrentPage: () => { },
};

export default ResearchApplicantTable;
